import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import { AccessToken } from "@/typescript/api_client/emesh_api/login/types";
import { GetUsersResponse } from "@/typescript/api_client/emesh_api/users/types";
import { GetStoreSensorsResponseSensor } from "@/typescript/api_client/emesh_api/stores/types";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    activeId: 0,
    isFolding: false,
    /** @type AccessToken|{} */
    authInfo: {} as AccessToken,
    isGraphLoading: false,
    userInfo: {} as GetUsersResponse,
    storeSensors: [] as GetStoreSensorsResponseSensor[],
    storeId: "",
    storeName: "",
    storeIsRemoval: false,
    sensorsTabName: ""
  },
  mutations: {
    setActiveId(state, payload) {
      state.activeId = payload.activeId;
    },
    setIsFolding(state, payload) {
      state.isFolding = payload.isFolding;
    },
    setAuthInfo(state, payload) {
      state.authInfo = payload.authInfo;
    },
    setUserInfo(state, payload) {
      state.userInfo = payload.userInfo;
    },
    setStoreSensors(state, payload) {
      state.storeSensors = payload.storeSensors;
    },
    setStoreInfo(state, payload) {
      state.storeId = payload.storeId;
      state.storeName = payload.storeName;
      state.storeIsRemoval = payload.storeIsRemoval;
    },
    setIsGraphLoading(state, payload) {
      state.isGraphLoading = payload.isGraphLoading;
    },
    setSensorsTabName(state, payload) {
      state.sensorsTabName = payload.sensorsTabName;
    }
  },
  actions: {},
  modules: {},
  plugins: [createPersistedState()]
});
